"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {on, find, findIn, findAllIn, addClass, removeClass, hasClass, setAttribute, removeAttribute, setText, append} from '@elements/dom-utils';

const selectors = {
    trigger: '.js-print-lightbox',
    modal: '.js-print-lightbox-modal',
    track: '.js-print-lightbox-modal__track',
    slide: '.js-print-lightbox-modal__slide',
    close: '.js-print-lightbox-modal__close',
    prev: '.js-print-lightbox-modal__prev',
    next: '.js-print-lightbox-modal__next',
    title: '.js-print-lightbox-modal__title',
    counter: '.js-print-lightbox-modal__counter'
};

let modal = null;
let pages = [];
let current = 0;

export function init () {
    onFind(selectors.trigger, function (triggerElement) {
        ensureModal();

        on('click', function () {
            open(triggerElement);
        }, triggerElement);
    });
}

// builds and wires the shared lightbox modal once, the first time a .js-print-lightbox trigger is found
function ensureModal () {
    if (modal) {
        return;
    }

    append(modalMarkup(), null, document.body);
    modal = find(selectors.modal);

    on('click', function (evt) {
        if (evt.target === modal || evt.target.classList.contains('brand-lightbox__inner')) {
            close();
        }
    }, modal);

    on('click', close, findIn(selectors.close, modal));
    on('click', function () {
        goTo(current - 1);
    }, findIn(selectors.prev, modal));
    on('click', function () {
        goTo(current + 1);
    }, findIn(selectors.next, modal));

    on('keydown', function (evt) {
        if (!hasClass('is-open', modal)) {
            return;
        }

        if (evt.key === 'Escape') {
            close();
        } else if (evt.key === 'ArrowLeft') {
            goTo(current - 1);
        } else if (evt.key === 'ArrowRight') {
            goTo(current + 1);
        }
    }, document);

    let track = findIn(selectors.track, modal);
    let touchStartX = null;

    on('touchstart', function (evt) {
        touchStartX = evt.changedTouches[0].screenX;
    }, track);

    on('touchend', function (evt) {
        if (touchStartX === null) {
            return;
        }

        let deltaX = evt.changedTouches[0].screenX - touchStartX;
        if (Math.abs(deltaX) > 40) {
            goTo(current + (deltaX < 0 ? 1 : -1));
        }

        touchStartX = null;
    }, track);
}

function open (triggerElement) {
    let raw = triggerElement.getAttribute('data-lightbox-pages') || '';
    let title = triggerElement.getAttribute('data-lightbox-title') || '';

    pages = raw.split(',').map((page) => page.trim()).filter(Boolean);
    current = 0;

    let track = findIn(selectors.track, modal);
    track.innerHTML = '';

    pages.forEach((src, index) => {
        let img = document.createElement('img');
        img.src = src;
        img.className = 'brand-lightbox__slide js-print-lightbox-modal__slide' + (index === 0 ? ' is-active' : '');
        img.alt = title + (pages.length > 1 ? ` – Seite ${index + 1}` : '');
        img.draggable = false;
        track.appendChild(img);
    });

    setText(title, findIn(selectors.title, modal));
    updateNav();

    addClass('is-open', modal);
    setAttribute('aria-hidden', 'false', modal);
    document.body.style.overflow = 'hidden';
    findIn(selectors.close, modal).focus();
}

function close () {
    removeClass('is-open', modal);
    setAttribute('aria-hidden', 'true', modal);
    document.body.style.overflow = '';
    findIn(selectors.track, modal).innerHTML = '';
    pages = [];
    current = 0;
}

function goTo (index) {
    let slides = findAllIn(selectors.slide, modal);
    if (!slides.length) {
        return;
    }

    removeClass('is-active', slides[current]);
    current = (index + pages.length) % pages.length;
    addClass('is-active', slides[current]);
    updateNav();
}

function updateNav () {
    let multi = pages.length > 1;
    let prevButton = findIn(selectors.prev, modal);
    let nextButton = findIn(selectors.next, modal);

    if (multi) {
        removeAttribute('hidden', prevButton);
        removeAttribute('hidden', nextButton);
    } else {
        setAttribute('hidden', 'hidden', prevButton);
        setAttribute('hidden', 'hidden', nextButton);
    }

    setText(multi ? `${current + 1} / ${pages.length}` : '', findIn(selectors.counter, modal));
}

function modalMarkup () {
    return `
        <div class="brand-lightbox js-print-lightbox-modal" role="dialog" aria-modal="true" aria-label="Vorschau" aria-hidden="true">
            <div class="brand-lightbox__toolbar">
                <span class="brand-lightbox__title js-print-lightbox-modal__title"></span>
                <span class="brand-lightbox__counter js-print-lightbox-modal__counter"></span>
            </div>
            <button type="button" class="brand-lightbox__close js-print-lightbox-modal__close" aria-label="Schließen">
                <span class="icon icon-close" aria-hidden="true"></span>
            </button>
            <div class="brand-lightbox__inner">
                <button type="button" class="brand-lightbox__btn brand-lightbox__prev js-print-lightbox-modal__prev" aria-label="Vorherige Seite">
                    <span class="icon icon-arrow-left" aria-hidden="true"></span>
                </button>
                <div class="brand-lightbox__track js-print-lightbox-modal__track"></div>
                <button type="button" class="brand-lightbox__btn brand-lightbox__next js-print-lightbox-modal__next" aria-label="Nächste Seite">
                    <span class="icon icon-arrow-right" aria-hidden="true"></span>
                </button>
            </div>
        </div>
    `;
}
